/** Firm region label for tables and Excel (arrays become comma-separated). */
export function formatRegionDisplay(regionNames: unknown): string {
  if (regionNames == null) {
    return "";
  }
  if (Array.isArray(regionNames)) {
    return regionNames
      .map((value) => String(value ?? "").trim())
      .filter(Boolean)
      .join(", ");
  }
  return String(regionNames).trim();
}
